// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6593) return "static/chunks/framework-f0486a883f1a3882.js";
	if (chunkId === 9292) return "static/chunks/9292-628a1f1bdfeabe54.js";
	if (chunkId === 5692) return "static/chunks/162013d4-447b73c97640eb84.js";
	if (chunkId === 8797) return "static/chunks/8797-f134015d5d2a3ccb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1388":"33250c6b6c3debee","1500":"08ed13a96eca80c4","7082":"0761c1ab88f0a74c","8499":"cb29aa990366fb3f"}[chunkId] + ".js";
};